module.exports = __webpack_public_path__ + "img/13.0e4e1300.jpg";